import template from './accountSelector.html';
import './accountSelector.scss';
/**
 * Handles the callback actions between the UI and the component implementation.
 */
class AccountSelectorController {
  /**
   * Informs the implementation that the user tried to filter the accounts list.
   * @param {string} text The text the user entered on the search box.
   */
  search(text) {
    this.onSearch({ text });
  }
  /**
   * Informs the implementation that the user selected an account.
   * @param {Object} account The selected account.
   */
  select(account) {
    if (this.canSelect) {
      this.onSelection({ account });
    }
  }
  /**
   * Informs the implementation that user wants to sign out.
   */
  signout() {
    this.onSignout();
  }
}
/**
 * Shows a list of accounts and, via callbacks, allows the user to filter them and select one.
 * @ngesdoc component
 * @ngname accountSelector
 * @ngcontroller {@link AccountSelectorController}
 * @ngmodule auth
 * @ngbinding {boolean}  loading     Whether or not the component should show a loading indicator.
 * @ngbinding {string}   subtitle    A subtitle to show under the logo.
 * @ngbinding {string}   error       An error message to show if the accounts are not available.
 * @ngbinding {string}   userName    The name of the user. To show it on a _"hello message"_.
 * @ngbinding {Array}    accounts    The list of accounts to show.
 * @ngbinding {boolean}  canSelect   Whether or not the user can select an account.
 * @ngbinding {Function} onSearch    The callback the component calls when the user tries to filter
 *                                   the accounts. It will receive a `text` parameter.
 * @ngbinding {Function} onSelection The callback the component calls when the user selectes an
 *                                   account. It will receive an `account` parameter.
 * @ngbinding {Function} onSignout   The callback the component calls when the user wants to stop
 *                                   the authentication process and sign out instead.
 */
const accountSelector = {
  controller: AccountSelectorController,
  template,
  bindings: {
    loading: '<',
    subtitle: '<',
    error: '<',
    userName: '<',
    accounts: '<',
    canSelect: '<',
    onSearch: '&',
    onSelection: '&',
    onSignout: '&',
  },
};

export { AccountSelectorController };
export default accountSelector;
